import React from 'react';

const SidebarRight = () => {
    return (
        <div className="sidebar">
            <div className="sidebar-item">
                <input
                    className="form-control form-control-md h-75 search-input"
                    placeholder="Ticker (ex. AAPL)"
                />
            </div>
            <div className="sidebar-item">
                {/* make links */}
                <p>Portfolio</p>
                <p>Watchlist</p>
            </div>
        </div>
    );
};

export default SidebarRight;
